import React from "react";

function LoadingBall() {
  return <span className="loading loading-ball w-[100px] text-primary"></span>;
}

export default LoadingBall;
